import * as React from 'react';
import { connect } from 'react-redux';
import { CAR_DETAILS, CREDIT_HISTORY, GET_CAR_INSURANCE } from '../../../routes/routes';
import { ProgressBar, Form, Button } from 'react-bootstrap';
import { navigateTo } from '../../../actions/navigationActions';
import { CarRegistrationCheck } from '../../../actions/salesActions';
import './CarRegistration.css';
import ReactTooltip from 'react-tooltip';

class CarRegistration extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            regNo: "",
            hasSubmitted: false,
            loggedIn: this.props.auth.uid ? true : false
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.handleDontKnow = this.handleDontKnow.bind(this);
        this.handleNext = this.handleNext.bind(this);
    }

    async handleChange(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        await this.setState({ [name]: value });
    }

    async handleBack(e: any) {
        if (this.props.profile.policyId !== "") {
            this.props.redirectTo(GET_CAR_INSURANCE)
        } else {
            this.props.redirectTo(CREDIT_HISTORY)
        }
    }

    async handleNext() {
        const { regNo } = this.state;
        await this.setState({ hasSubmitted: true });

        if (regNo !== "") {
            await this.props.dispatchCarRegistration(this.state.regNo);
        }
    }

    handleDontKnow() {
        this.props.redirectTo(CAR_DETAILS);
    }

    public render() {

        const { regNo, hasSubmitted } = this.state;
        return (
            <div className={this.state.loggedIn ? "pt-lg-5 p-lg-0 logged-in" : "pt-lg-5 p-lg-05 logged-out"}>
                <div className="col-12 mt-4 pb-4 text-lg-center text-md-center">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10 col-md-12">
                                <div className="row justify-content-center">
                                    <div className="col-2 col-md-3 col-lg-3 col-xl-2 pt-lg-2 text-center align-self-center">
                                        <div className="BackRectangle d-none d-lg-block d-md-block">
                                            <Button onClick={this.handleBack} className="Back cursor-pointer" id="btnBackDesktop"><img src="./images/OnlineQuotation/icon-back-button-desktop.png" alt="" /></Button>
                                        </div>
                                        <div className="sidenav d-lg-none d-md-none" id="mySidenav">
                                            <Button onClick={this.handleBack} className="Back cursor-pointer" id="btnBackMobile"><img src="./images/OnlineQuotation/icons-navigation-quote-back-btn.png" alt="" /></Button>
                                        </div>
                                    </div>
                                    <div className="col-10 col-md-9 col-lg-9 col-xl-10 p-0 text-center align-self-center">
                                        <div>
                                            <ProgressBar variant="success" now={35} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10 col-md-12">
                                <div className="mt-5 text-center">
                                    <img src="./images/OnlineQuotation/crown-icon.png" alt="" className="img-fluid" />
                                </div>
                                <div className="ma-top-21px text-center">
                                    <p className="text-16 font-weight-500">Excellent, now we need your car’s details. The easiest way to get<br className="d-none d-lg-block" /> this is by using your registration number.
                                        <img className="raftooltip ml-10px" id="rafTooltip" alt="" src="./images/icons-line-style-info-32-px.svg" data-for="carRegistrationTooltip" data-tip="" />
                                        <ReactTooltip id="carRegistrationTooltip" className="rafreacttool" place="right" effect="solid" backgroundColor="#3a1826" delayShow={1000} >We check your car’s registration number in TransUnion’s database and from there we can automatically fill in your car’s details.</ReactTooltip>
                                    </p>
                                </div>
                                <div className="form-row noma car-extra-info">
                                    <div className="col-12 nopa">
                                        <p className="mb-0px font-weight-bold">Please note that cars used for any of the following purposes are not covered by the king:</p>
                                    </div>
                                    <div className="col-12 nopa">
                                        <ul className="mb-0px pl-25px">
                                            <li>Emergency services,</li>
                                            <li>Armed response,</li>
                                            <li>Law enforcement,</li>
                                            <li>Driving instructions,</li>
                                            <li>Towing purposes,</li>
                                            <li>Rental purposes,</li>
                                            <li>Taxis or transporting of fare paying passengers.</li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="form-row mb-lg-1 mb-2">
                                    <div className="col-12">
                                        <div className={'form-group' + (hasSubmitted && regNo ==="" ? ' has-error' : '')}>
                                            <Form.Label className={'left-align temp-text-box-label pl-1' + (this.state.regNo !== "" ? "" : " no-opacity")}>Reg no.</Form.Label>
                                            <Form.Control type="text" placeholder="Reg no." id="RegNrInputId" name="regNo" value={this.state.regNo} onChange={this.handleChange} />
                                            {hasSubmitted && regNo === "" &&
                                                <div className="help-block">Reg no is required</div>
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="row d-flex justify-content-center mt-lg-4">
                                    <div className="col-md-6 col-xl-4 col-12 text-right">
                                        <button type="submit" className="btn btn-outline-red mt-3 mt-lg-0 w-100 cursor-pointer" id="DontKnowButton" onClick={this.handleDontKnow}>Don’t know it</button>
                                    </div>
                                    <div className="col-md-6 col-xl-4 col-12">
                                        <Button type="submit" className="btn btn-block btn-solid-red mt-3 mt-lg-0 pl-3 cursor-pointer" id="NextButton" onClick={this.handleNext}>Next</Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        auth: state.firebase.auth,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (des) => dispatch(navigateTo(des)),
        dispatchCarRegistration: (regNr: any) => dispatch(CarRegistrationCheck(regNr)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CarRegistration);